module.exports = __webpack_public_path__ + "img/share-tip.3ef4e8dc.png";